export const SET_NOT_SURE_ANSWERED_QUESTIONS = 'INTAKE/SET_NOT_SURE_ANSWERED_QUESTIONS';
